import React from "react";
import { StatusLabelPresenter, PresenterProps } from "./StatusLabel";

export type StatusLabelProps = PresenterProps;

export const StatusLabel: React.FC<StatusLabelProps> = (props) => {
  return <StatusLabelPresenter {...props}></StatusLabelPresenter>;
};
